export default __webpack_public_path__ + "static/media/matrix-logo.ccf0e872.png";